import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Box, List, ListItem, ListItemText, Collapse } from "@mui/material"; // Import Collapse for dropdown
import DashboardIcon from "@mui/icons-material/Dashboard";
import { Menu } from '@mui/icons-material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import {  Payment } from '@mui/icons-material';
import {  AccountBalanceWallet } from '@mui/icons-material';
import { Receipt } from '@mui/icons-material';
import {  Category } from '@mui/icons-material';
import {  ThumbUp } from '@mui/icons-material';
import {  Assessment } from '@mui/icons-material';
import {  SupportAgent } from '@mui/icons-material';
import { Update } from '@mui/icons-material';
import { HelpOutline } from '@mui/icons-material';
import {  Verified } from '@mui/icons-material';
import {  Add } from '@mui/icons-material';
import {  Newspaper } from '@mui/icons-material';












import Logout from "./Logout/Logout";

const Sidebar = () => {
  // Step 1: Add state to manage the wallet dropdown
  const [isWalletOpen, setIsWalletOpen] = useState(false);
  const [isInvoicesOpen, setIsInvoicesOpen] = useState(false);
  const [isProductOpen, setIsProductOpen] = useState(false);
  const [isApprovalOpen, setIsApprovalOpen] = useState(false);
  const [isReportOpen, setIsReportOpen] = useState(false);
  const [isCustomerOpen, setIsCustomerOpen] = useState(false);
  const [isUpdateOpen, setIsUpdateOpen] = useState(false);
  const [isFaqOpen, setIsFaqOpen] = useState(false);
  const [isKycOpen, setIsKycOpen] = useState(false);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isAddNewsOpen, setIsAddNewsOpen] = useState(false);
  const [isBbpsOpen, setIsBbpsOpen] = useState(false);
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);

  // Step 2: Define toggle function for invoice menu
  const toggleWalletMenu = () => {
    setIsWalletOpen((prevState) => !prevState);
  };
  const toggleInvoicesMenu = () => {
    setIsInvoicesOpen((prevState) => !prevState);
  };
  const toggleProductMenu = () => {
    setIsProductOpen((prevState) => !prevState);
  };
  const toggleApprovalMenu = () => {
    setIsApprovalOpen((prevState) => !prevState);
  };
  const toggleReportMenu = () => {
    setIsReportOpen((prevState) => !prevState);
  };
  const toggleCustomerMenu = () => {
    setIsCustomerOpen((prevState) => !prevState);
  };
  const toggleUpdateMenu = () => {
    setIsUpdateOpen((prevState) => !prevState);
  };
  const toggleFaqMenu = () => {
    setIsFaqOpen((prevState) => !prevState);
  };
  const toggleKycMenu = () => {
    setIsKycOpen((prevState) => !prevState);
  };
  const toggleAddMenu = () => {
    setIsAddOpen((prevState) => !prevState);
  };
  const toggleAddNewsMenu = () => {
    setIsAddNewsOpen((prevState) => !prevState);
  };
  const toggleBbpsMenu = () => {
    setIsBbpsOpen((prevState) => !prevState);
  };
  const togglePaymentMenu = () => {
    setIsPaymentOpen((prevState) => !prevState);
  };

  return (
    <Box
      sx={{
        width: "250px",
        bgcolor: "#f8f9fa",
        height: "100vh",
        padding: "1rem",
      }}
    >
      <List>
        <ListItem button component={Link} to="/dashboard">
          <DashboardIcon sx={{ marginRight: 2 }} />
          <ListItemText primary="Dashboard" />
        </ListItem>
        <ListItem button component={Link} to="/users">
        <AccountCircleIcon sx={{ marginRight: 2 }} />
          <ListItemText primary="Users" />
        </ListItem>

        {/* adding payment */}
        <ListItem button onClick={togglePaymentMenu}>
        <Payment style={{ marginRight: "8px" }} />
          <ListItemText primary="Payment" />
          {/* Conditional rendering of the chevron icon */}
          <i
            className={`bi ${
              isPaymentOpen ? "bi-chevron-up" : "bi-chevron-down"
            }`}
          />
        </ListItem>
        {/* use collapse for the Payment submenu */}
        <Collapse in={isPaymentOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button component={Link} to="/Odhwallet">
            
              <ListItemText primary="Add ODH Group Wallet" />
            </ListItem>
          </List>
        </Collapse>

        {/* Wallet link with toggle functionality */}
        <ListItem button onClick={toggleWalletMenu}>
        <AccountBalanceWallet style={{ marginRight: "8px" }} />
          <ListItemText primary="Wallet" />
          {/* Conditional rendering of the chevron icon */}
          <i
            className={`bi ${
              isWalletOpen ? "bi-chevron-up" : "bi-chevron-down"
            }`}
          />
        </ListItem>

        {/* Step 3: Use Collapse for the wallet submenu */}
        <Collapse in={isWalletOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button component={Link} to="/Odhmoney">
              <ListItemText primary="ODH Money" />
            </ListItem>
            <ListItem button component={Link} to="/Returnwallet">
              <ListItemText primary="Return Wallet" />
            </ListItem>
            <ListItem button component={Link} to="Withdrawl">
              <ListItemText primary="Withdrawal Wallet" />
            </ListItem>
            <ListItem button component={Link} to="/Offlinerequest">
              <ListItemText primary="Offline Wallet Request" />
            </ListItem>
          </List>
        </Collapse>

        {/* adding invoices */}

        <ListItem button onClick={toggleInvoicesMenu}>
        <Receipt style={{ marginRight: "8px" }} />
          <ListItemText primary="Invoices" />
          {/* Conditional rendering of the chevron icon */}
          <i
            className={`bi ${
              isInvoicesOpen ? "bi-chevron-up" : "bi-chevron-down"
            }`}
          />
        </ListItem>
        {/* use collapse for the invoices submenu */}
        <Collapse in={isInvoicesOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button component={Link} to="/invoices/rechargeandbill">
              <ListItemText primary="Recharge and Bill" />
            </ListItem>
            <ListItem button component={Link} to="/invoices/addmoney">
              <ListItemText primary="Add odh money" />
            </ListItem>
            <ListItem button component={Link} to="/invoices/addwallet">
              <ListItemText primary="Add Wallet" />
            </ListItem>
          </List>
        </Collapse>

        {/* adding products */}
        <ListItem button onClick={toggleProductMenu}>
        <Category style={{ marginRight: "8px" }} />
          <ListItemText primary="Product" />
          {/* Conditional rendering of the chevron icon */}
          <i
            className={`bi ${
              isProductOpen ? "bi-chevron-up" : "bi-chevron-down"
            }`}
          />
        </ListItem>
        {/* use collapse for the product submenu */}
        <Collapse in={isProductOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button component={Link} to="/product/createcategory">
              <ListItemText primary="Create Category" />
            </ListItem>
            <ListItem button component={Link} to="/product/createsubcategory">
              <ListItemText primary="Create Sub Category" />
            </ListItem>
            <ListItem
              button
              component={Link}
              to="/product/createdessubcategory"
            >
              <ListItemText primary="Create Des sub Category" />
            </ListItem>
            <ListItem button component={Link} to="/product/createunit">
              <ListItemText primary="Create Unit" />
            </ListItem>
            <ListItem button component={Link} to="/product/createbrand">
              <ListItemText primary="Create Brand" />
            </ListItem>
            <ListItem button component={Link} to="/product/createproduct">
              <ListItemText primary="Create Product" />
            </ListItem>
            <ListItem button component={Link} to="/product/addbanner">
              <ListItemText primary="Add Banner" />
            </ListItem>
            <ListItem button component={Link} to="/product/addproducttemplate">
              <ListItemText primary="Add Product Template" />
            </ListItem>
            <ListItem button component={Link} to="/product/addsize">
              <ListItemText primary="Add Size" />
            </ListItem>
          </List>
        </Collapse>

        {/* adding approval */}

        <ListItem button onClick={toggleApprovalMenu}>
        <ThumbUp style={{ marginRight: "8px" }} />
          <ListItemText primary="Approval" />
          {/* Conditional rendering of the chevron icon */}
          <i
            className={`bi ${
              isApprovalOpen ? "bi-chevron-up" : "bi-chevron-down"
            }`}
          />
        </ListItem>
        {/* use collapse for the approval submenu */}
        <Collapse in={isApprovalOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button component={Link} to="/approval/kycapproval">
              <ListItemText primary="KYC Approval" />
            </ListItem>
          </List>
        </Collapse>
        {/* adding reports */}
        <ListItem button onClick={toggleReportMenu}>
        <Assessment style={{ marginRight: "8px" }} />
          <ListItemText primary="Reports" />
          {/* Conditional rendering of the chevron icon */}
          <i
            className={`bi ${
              isReportOpen ? "bi-chevron-up" : "bi-chevron-down"
            }`}
          />
        </ListItem>
        {/* use collapse for the report submenu */}
        <Collapse in={isReportOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button component={Link} to="/report/balancesheet">
              <ListItemText primary="Balance Sheet" />
            </ListItem>
            <ListItem
              button
              component={Link}
              to="/report/beneficiarytranscation"
            >
              <ListItemText primary="Beneficiary Transcation" />
            </ListItem>
            <ListItem button component={Link} to="/report/addwallet">
              <ListItemText primary="Add Wallet Credit/Debit" />
            </ListItem>
            <ListItem button component={Link} to="/report/investmentlist">
              <ListItemText primary="Investment List" />
            </ListItem>
            <ListItem button component={Link} to="/report/interestonwallet">
              <ListItemText primary="Interest On Wallet" />
            </ListItem>
            <ListItem button component={Link} to="/report/customerlist">
              <ListItemText primary="Customer List" />
            </ListItem>
            <ListItem button component={Link} to="/report/sellerlist">
              <ListItemText primary="Seller List" />
            </ListItem>
            <ListItem button component={Link} to="/report/memberwiseincome">
              <ListItemText primary="MemberWise Income " />
            </ListItem>
            <ListItem button component={Link} to="/report/membercredit/debit">
              <ListItemText primary="Member Credit/Debit" />
            </ListItem>
            <ListItem button component={Link} to="/report/orderproduct">
              <ListItemText primary="Order Product" />
            </ListItem>
            <ListItem button component={Link} to="/report/rechargehistory">
              <ListItemText primary="Recharge History" />
            </ListItem>
            <ListItem button component={Link} to="/report/activatemembertxn">
              <ListItemText primary="Activate Member Trxn" />
            </ListItem>
            <ListItem button component={Link} to="/report/failrechargehistory">
              <ListItemText primary="Fail Recharge History" />
            </ListItem>
            <ListItem button component={Link} to="/report/hotelbookinglist">
              <ListItemText primary="Hotel Booking List" />
            </ListItem>
            <ListItem
              button
              component={Link}
              to="/report/refundhotelcacellation"
            >
              <ListItemText primary="Refund Hotel Cancellation" />
            </ListItem>
            <ListItem button component={Link} to="/report/odhpaymoneymember">
              <ListItemText primary="ODH Pay Money Member" />
            </ListItem>
          </List>
        </Collapse>
        {/* adding   customer care */}

        <ListItem button onClick={toggleCustomerMenu}>
        <SupportAgent style={{ marginRight: "8px" }} />
          <ListItemText primary="Customer Care" />
          {/* Conditional rendering of the chevron icon */}
          <i
            className={`bi ${
              isCustomerOpen ? "bi-chevron-up" : "bi-chevron-down"
            }`}
          />
        </ListItem>
        {/* use collapse for the customer submenu */}
        <Collapse in={isCustomerOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              button
              component={Link}
              to="/customercare/changecertificate"
            >
              <ListItemText primary="Change Certificate" />
            </ListItem>
            <ListItem
              button
              component={Link}
              to="/customercare/problemapproval"
            >
              <ListItemText primary="Problem Approval" />
            </ListItem>
          </List>
        </Collapse>

        {/* adding update */}

        <ListItem button onClick={toggleUpdateMenu}>
        <Update style={{ marginRight: "8px" }} />
          <ListItemText primary="Update" />
          {/* Conditional rendering of the chevron icon */}
          <i
            className={`bi ${
              isUpdateOpen ? "bi-chevron-up" : "bi-chevron-down"
            }`}
          />
        </ListItem>
        {/* use collapse for the customer submenu */}
        <Collapse in={isUpdateOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button component={Link} to="/update/updateproduct">
              <ListItemText primary="Update Product" />
            </ListItem>
            <ListItem button component={Link} to="/update/updatestatus">
              <ListItemText primary="Update Status" />
            </ListItem>
            <ListItem button component={Link} to="/update/updateuserdetail">
              <ListItemText primary="Update User Detail" />
            </ListItem>
            <ListItem button component={Link} to="/update/updatemargin">
              <ListItemText primary="Update Margin" />
            </ListItem>
            <ListItem button component={Link} to="/update/updatebillerimage">
              <ListItemText primary="Upload Biller Image" />
            </ListItem>
            <ListItem button component={Link} to="/update/updatebanklogo">
              <ListItemText primary="Upload Bank Logo" />
            </ListItem>
          </List>
        </Collapse>
        {/* Adding FAQ */}
        <ListItem button onClick={toggleFaqMenu}>
        <HelpOutline style={{ marginRight: "8px" }} />
          <ListItemText primary="FAQ" />
          {/* Conditional rendering of the chevron icon */}
          <i
            className={`bi ${isFaqOpen ? "bi-chevron-up" : "bi-chevron-down"}`}
          />
        </ListItem>
        {/* use collapse for the FAQ submenu */}
        <Collapse in={isFaqOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button component={Link} to="/faq">
              <ListItemText primary="FAQ" />
            </ListItem>
          </List>
        </Collapse>

        {/* KYC approve */}

        <ListItem button onClick={toggleKycMenu}>
        <Verified style={{ marginRight: "8px" }} />
          <ListItemText primary="KYC Approve" />
          {/* Conditional rendering of the chevron icon */}
          <i
            className={`bi ${isKycOpen ? "bi-chevron-up" : "bi-chevron-down"}`}
          />
        </ListItem>
        {/* use collapse for the KYC submenu */}
        <Collapse in={isKycOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button component={Link} to="/kyc/pandetail">
              <ListItemText primary="Seller Pan Detail" />
            </ListItem>
            <ListItem button component={Link} to="/kyc/bankdetail">
              <ListItemText primary="Seller Bank Detail" />
            </ListItem>
            <ListItem button component={Link} to="/kyc/adhardetail">
              <ListItemText primary="Seller Adhar Detail" />
            </ListItem>
            <ListItem button component={Link} to="/kyc/contactdetail">
              <ListItemText primary="Seller Contact Detail" />
            </ListItem>
            <ListItem button component={Link} to="/kyc/productapprove">
              <ListItemText primary="Product Approve" />
            </ListItem>
          </List>
        </Collapse>

        {/* adding add */}
        <ListItem button onClick={toggleAddMenu}>
        <Add style={{ marginRight: "8px" }} />
          <ListItemText primary="Add" />
          {/* Conditional rendering of the chevron icon */}
          <i
            className={`bi ${isAddOpen ? "bi-chevron-up" : "bi-chevron-down"}`}
          />
        </ListItem>
        {/* use collapse for the Add submenu */}
        <Collapse in={isAddOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button component={Link} to="/add/addoffer">
              <ListItemText primary="Add Offer" />
            </ListItem>
            <ListItem button component={Link} to="/add/addappbanner">
              <ListItemText primary="Add App Banner" />
            </ListItem>
          </List>
        </Collapse>

        {/* Add News */}
        <ListItem button onClick={toggleAddNewsMenu}>
        <Newspaper style={{ marginRight: "8px" }} />
          <ListItemText primary="Add News" />
          {/* Conditional rendering of the chevron icon */}
          <i
            className={`bi ${
              isAddNewsOpen ? "bi-chevron-up" : "bi-chevron-down"
            }`}
          />
        </ListItem>
        {/* use collapse for the AddNews submenu */}
        <Collapse in={isAddNewsOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button component={Link} to="/add/addnews">
              <ListItemText primary="Add News" />
            </ListItem>
          </List>
        </Collapse>
        {/* Adding BBPS */}

        <ListItem button onClick={toggleBbpsMenu}>
        <Menu style={{ marginRight: "8px" }} />
          <ListItemText primary="BBPS" />
          {/* Conditional rendering of the chevron icon */}
          <i
            className={`bi ${isBbpsOpen ? "bi-chevron-up" : "bi-chevron-down"}`}
          />
        </ListItem>
        {/* use collapse for the BBPS submenu */}
        <Collapse in={isBbpsOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button component={Link} to="/bbps/transcationquery">
              <ListItemText primary="Transcation Query" />
            </ListItem>
            <ListItem button component={Link} to="/bbps/raisecomplaint">
              <ListItemText primary="Raise Complaint" />
            </ListItem>
            <ListItem button component={Link} to="/bbps/complaintstatus">
              <ListItemText primary="Complaint Status" />
            </ListItem>
          </List>
        </Collapse>
        {/* adding logout */}
        <ListItem button component={Link} to="/bbps/logout">
        <LogoutIcon sx={{ marginRight: 2 }} />
          <ListItemText primary="Logout" />
        </ListItem>
      </List>
    </Box>
  );
};

export default Sidebar;
